import { render } from "./ReceiptView.vue?vue&type=template&id=a9b537d0"
import script from "./ReceiptView.vue?vue&type=script&lang=js"
export * from "./ReceiptView.vue?vue&type=script&lang=js"

import "./ReceiptView.vue?vue&type=style&index=0&id=a9b537d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__